import { render, staticRenderFns } from "./SetupReminderDropdown.vue?vue&type=template&id=2b8ac6e5&scoped=true&"
import script from "./SetupReminderDropdown.vue?vue&type=script&lang=js&"
export * from "./SetupReminderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SetupReminderDropdown.vue?vue&type=style&index=0&id=2b8ac6e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ac6e5",
  null
  
)

export default component.exports